import { render, staticRenderFns } from "./MenuSidebar.vue?vue&type=template&id=55c8ceae&scoped=true&"
import script from "./MenuSidebar.vue?vue&type=script&lang=js&"
export * from "./MenuSidebar.vue?vue&type=script&lang=js&"
import style0 from "./MenuSidebar.vue?vue&type=style&index=0&id=55c8ceae&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55c8ceae",
  null
  
)

export default component.exports